<template>
    <div class="notice content-continer" style="min-height: 760px;">
        <div class="notice-title">{{title}}</div>
        <ul>
            <li v-for="item in list">
                <span class="title-icon"></span>
                <router-link :to="`/Msg/`+item.newsId">{{item.newsTitle}}</router-link>
                <span class="time">{{item.createTime}}</span>
            </li>
        </ul>
        <div class="center">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
             :page-size='50' layout="total, prev, pager, next, jumper" :total='total'>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import { gethomelist } from '@/request/api'
    export default {
        name: "notice",
        data() {
            return {
                list: '',
                id: '',
                title: '',
                total: ''
            };
        },
        methods: {
            // 鼠标移入加入class
            changeActive($event) {
                $event.currentTarget.className = "list-active";
            },
            removeActive($event) {
                $event.currentTarget.className = "";
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id == 8) {
                this.title = "常见问题"
            } else if (this.id == 7) {
                this.title = "通知公告"
            } else {
                this.title = "行业资讯"
            }
            gethomelist(this.id, 11, 50).then((res) => {
                this.list = res.data.data;
                this.total = res.data.totalRows
            }).catch((err) => {
                console.log(err)
            })
        },
        // beforeCreate() {
        //     document.querySelector('body').setAttribute('style', 'background-color:#F5F5F5;')
        // },
        // //销毁前清除
        // beforeDestroy() {
        //     document.querySelector('body').removeAttribute('style')
        // }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .notice-title {
        color: #3672BF;
        border-bottom: solid 1px #3672BF;
        margin-top: 50px;
        padding-bottom: 15px;
        font-size: 18px;
        font-weight: bold;
        padding-left: 20px;
    }

    .notice li {
        height: 56px;
        cursor: pointer;
        font-size: 18px;
        border-bottom: dashed 1px #CCCCCC;
    }

    .notice a {
        font-size: 14px;
        color: #4d4d4d;
        margin-left: 20px;
        line-height: 56px;

    }

    .notice ul {
        margin-bottom: 100px;
    }

    .title-icon {
        display: inline-block;
        width: 4px;
        height: 4px;
        background: #4d4d4d;
        margin-top: 28px;
        float: left;
    }

    .time {
        font-size: 12px;
        display: inline-block;
        padding: 0 10px;
        height: 18px;
        border: 1px solid rgba(204, 204, 204, 1);
        color: #CCCCCC;
        float: right;
        margin-top: 19px;
    }
</style>


// WEBPACK FOOTER //
// src/components/notice.vue